<template>
    <div v-for="type in types">
        <span class="flex cursor-pointer" v-if="isType(type)">
            <input
                type="radio"
                name="file_type"
                :id="`file_meta_data_${type}`"
                :value="`file_meta_data_${type}`"
                :checked="isType(type)"
                @input="$emit('update:fileType', $event.target.value)"
            >
            <label
                class="text-sm ml-2 cursor-pointer"
                :for="`file_meta_data_${type}`"
            >
                    {{ __('type.' + type) }}
            </label>
        </span>
    </div>
</template>

<script>
import {fileTypes} from './MediaLibraryLogic'
import { __ } from '@/locale';
// this whole component is not the best solution
// @refactor
export default {
    props: ['object_type', 'fileType'],
    emits: ['update:fileType'],
    data() {
        return {
            __,
            types: fileTypes,
        }
    },
    mounted() {
        this.$emit('update:fileType', `file_meta_data_${this.fileType}`);
    },
    watch: {
        fileType(newVal, oldVal) {
            this.$emit('update:fileType', `file_meta_data_${newVal}`);
        }
    },
    methods: {
        isType(abstractType) {
            return abstractType === this.fileType;
        },
    },
}
</script>
